module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jobs"
  }, [_c('navbar'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "md-display-3 bottomSpace"
  }, [_vm._v("Join us because it's awesome!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('md-button', {
    staticClass: " md-raised md-primary",
    attrs: {
      "href": "#h1"
    }
  }, [_vm._v("See open positions")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h1', {
    staticClass: "md-display-3",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "h1"
    }
  }, [_vm._v(" Open positions: ")]), _vm._v(" "), _c('div', {
    staticClass: "md-card-container row "
  }, _vm._l((_vm.jobs), function(job) {
    return _c('div', {
      staticClass: "col-md-6"
    }, [_c('md-card', {
      staticClass: "card"
    }, [_c('md-card-header', {
      staticClass: "md-primary"
    }, [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(job.title) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('md-card-expand', [_c('md-card-actions', [_c('md-button', {
      staticClass: "md-icon-button",
      attrs: {
        "md-expand-trigger": ""
      }
    }, [_c('md-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _c('md-card-content', [_c('span', {
      staticClass: "md-subheading"
    }, [_vm._v("Description:")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "md-body2"
    }, [_vm._v(_vm._s(job.description))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
      staticClass: "md-raised md-primary"
    }, [_vm._v("Apply")])], 1), _vm._v(" "), _c('span', {
      staticClass: "footers"
    }, [_c('span', {
      staticStyle: {}
    }, [_vm._v("Work hours:")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(job.work_hours + " hours/week"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Salary range:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(job.salary_range) + " €")])])], 1)], 1)], 1)], 1)
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "md-subheading",
    staticStyle: {
      "text-align": "center",
      "color": "indigo"
    }
  }, [_vm._v("\n\t\t\tWork with us on the most-convinient health tracking software to help the lives of chronic desease patients.\n\t\t\tWe are looking for university students, who are determined enough to consider a "), _c('br'), _vm._v("\n\t\t\tproduct as their own child, and ready to experiment with new solutions. All of the listed job opportunites are very flexible.\n\t\t\tWe can support you with professional practice and public research"), _c('br'), _vm._v(" projects. Please write us,  if you are interested in the healthcare\n\t\t\tfield, and you feel like your expertise could be valuable for our project.\n\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-container"
  }, [_c('p', {
    staticClass: "md-display-3 bottomSpace"
  }, [_vm._v("Why us?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container bottomSpace col-md-6"
  }, [_c('p', [_vm._v(" sdsaportunites are very flexible."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tWe can support you with professional "), _c('br'), _vm._v("practice and public research"), _c('br')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/icons/001-pint.png"),
      "alt": "we love our team!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container bottomSpace col-md-6"
  }, [_c('p', [_vm._v(" sdsaportunites are very flexible."), _c('br'), _vm._v("\n\t\t\t\t\t\tWe can support you with professional "), _c('br'), _vm._v("practice and public research"), _c('br')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/icons/002-collaboration.png"),
      "alt": "we love our team!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container bottomSpace col-md-6"
  }, [_c('p', [_vm._v(" sdsaportunites are very flexible."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tWe can support you with professional "), _c('br'), _vm._v("practice and public research"), _c('br')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/icons/003-earning.png"),
      "alt": "we love our team!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container bottomSpace col-md-6"
  }, [_c('p', [_vm._v(" sdsaportunites are very flexible."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tWe can support you with professional "), _c('br'), _vm._v("practice and public research"), _c('br')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/icons/004-student.png"),
      "alt": "we love our team!"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ea0a1c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JobsView.vue
// module id = 409
// module chunks = 2